import { RouteConfig } from "vue-router";
import Landing from "../views/Landing.vue";

const routes: Array<RouteConfig> = [{
                path: '/landing',
                name: 'landing-root',
                component: Landing,
        }, {
                path: '/login',
                name: 'login',
                component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
        }, {
                path: '/forgot-password',
                name: 'forgot-password-user',
                component: () => import(/* webpackChunkName: "forgot-password-user" */ '../views/ForgotPassword.vue')
        }, {
                path: '/register',
                name: 'register-user',
                component: () => import(/* webpackChunkName: "register-user" */ '../views/RegisterUser.vue')
        }, {
                path: '/prices',
                name: 'tayeh-prices',
                component: () => import(/* webpackChunkName: "tayeh-prices" */ '../views/Prices.vue')
        }, {
                path: '/about-us',
                name: 'about-us',
                component: () => import(/* webpackChunkName: "tayeh-prices" */ '../views/About.vue')
        }, {
                path: '/payment-response/:payment_gate',
                name: 'payment-response',
                component: () => import(/* webpackChunkName: "payment-response" */ '../views/PaymentResponse.vue')
        }, {
                path: '/deposit-response/',
                name: 'user-deposit-response',
                component: () => import(/* webpackChunkName: "user-deposit-response" */ '../views/UserDepositResponse.vue')
        }, {
                path: '/customer-deposit-response/:payment_gate',
                name: 'customer-deposit-response',
                component: () => import(/* webpackChunkName: "customer-deposit-response" */ '../views/CustomerDepositResponse.vue')
        }, {
                path: '/pay-cart',
                name: 'pay-cart',
                component: () => import(/* webpackChunkName: "PayCart" */ '../views/PayCart.vue')
        }
]

export default routes;